import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './components/Home';
import Desktop from './components/Desktop';
import AppPage from './pages/AppPage';
import EspPage from './pages/EspPage';
import { APPS } from './apps';

function App() {
  const { pathname } = useLocation();

  // 路由变化时回到顶部，并同步页面标题
  useEffect(() => {
    window.scrollTo(0, 0);

    if (pathname === '/desktop') {
      document.title = '桌面';
      return;
    }

    if (pathname !== '/') {
      if (pathname === '/esp') {
        document.title = 'ESP 前端展示';
        return;
      }

      const app = APPS.find((item) => item.path === pathname);
      document.title = app ? app.name : '未找到';
      return;
    }

    document.title = 'miso';
  }, [pathname]);

  return (
    <Routes>
      {/* IDLE：主界面，右下角 FAB 是桌面的唯一入口 */}
      <Route path="/" element={<Home />} />

      {/* DESKTOP_OPEN：桌面层，全屏壁纸 + 图标网格，无 FAB */}
      <Route path="/desktop" element={<Desktop />} />

      {/* ESP：真实功能页，不属于占位 APP */}
      <Route path="/esp" element={<EspPage />} />

      {/* NAVIGATING：图标点击后进入的具体功能页，与 eg 平级 */}
      <Route path="/:appId" element={<AppPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
